import React             from "react";
import { createBrowserRouter, RouterProvider } from "react-router";
import { redirect, RouteObject } from "react-router-dom";
import { MainLayout } from "../components/layout/MainLayout";
import DashboardPage from "../pages/dashboard/DashboardPage";
import Login from "../pages/login/Login";
import ProtectedRoute from "../hooks/protectedRoute";
import OrderPage from "../pages/orders/OrderPage";
import ForgotPassword from "../pages/forgot-password/ForgotPassword";
import ResetPassword from "../pages/reset-password/ResetPassword";
import ResetPasswordConfirm from "../pages/reset-password/ResetPasswordConfirm";
import SettingsPage from "../pages/settings/SettingsPage";

export const routes:Array<RouteObject & {title?: string} & {parent?: string}> = [
    {
        path: "/",
        loader: () => redirect("/Dashboard"),
    },
    {
        path: "/Login",
        element: (
            <Login/>
        ),
        title: "Login",
    },
    {
        path: "/Dashboard",
        element: (
            <ProtectedRoute>
                <MainLayout>
                    <DashboardPage/>
                </MainLayout>
            </ProtectedRoute>
        ),
        title: "Dashboard",
    },
    {
        path: "/Orders",
        element: (
            <ProtectedRoute>
                <MainLayout>
                    <OrderPage/>
                </MainLayout>
            </ProtectedRoute>
        ),
        title: "Orders",
    },
    {
        path: "/Settings",
        element: (
            <ProtectedRoute>
                <MainLayout>
                    <SettingsPage/>
                </MainLayout>
            </ProtectedRoute>
        ),
        title: "Settings",
    },
    {
        path: "/forgot-password",
        element: (
            <ForgotPassword/>
        ),
        title: "Forgot-password",
    },
    {
        path: "/reset-password",
        element: (
            <ResetPassword/>
        ),
        title: "reset-password",
    },
    {
        path: "/reset-password-confirm",
        element: (
            <ResetPasswordConfirm/>
        ),
        title: "reset-password-confirm",
    },
    {
        path: "*",
        loader: () => redirect("/Dashboard"),
    },
];

export const RoutesContext = React.createContext(routes);

export const CurrentRouter = createBrowserRouter(routes, {basename: '/'});

export const ClientPortalRouter = () =>
{
    return (
        <RouterProvider router={CurrentRouter}/>
    );
};

export default ClientPortalRouter;
